import Hero from "../components/Hero";
import ServiceTimes from "../components/ServiceTimes";
import About from "../components/About";
import Ministries from "../components/Ministries";
import BeliefsPreview from "../components/BeliefsPreview";
import Sermons from "../components/Sermons";
import Gallery from "../components/Gallery";
import Donate from "../components/Donate";
import PrayerRequest from "../components/PrayerRequest";
import Visit from "../components/Visit";
import StaffPreview from "../components/StaffPreview";

export default function Home() {
  return (
    <main>
      <Hero />
      <ServiceTimes />
      <About />
      <Ministries />
      <StaffPreview />
      <BeliefsPreview />
      <Sermons />
      <Gallery />
      <Donate />
      <PrayerRequest />
      <Visit />
    </main>
  );
}
